import i18n from "consts/i18n"

export const generateButtonText = ({ programIsUnavailable }) => {
  if (programIsUnavailable) {
    return i18n.deepLinkPage.programUnavailableBtn
  }

  return i18n.deepLinkPage.watchNow
}
